import React from "react"
import WaveBg from "../../components/wave-bg"
import styles from "./index.module.css"
import Lottie from "lottie-react"
import introImage from "./introImage.json";

export default () => (
    <div id="home" style={{ height: "100vh" }}>
        <WaveBg>
            <div className="row align-items-center justify-content-center text-center" style={{ height: "100vh" }}>
                <div className="col-12 col-sm-6 d-flex flex-column align-items-center">
                    {/* <img alt="Rishi Vedpathak" src="/illustrations/intro.svg" className="d-sm-none img-fluid mb-5" style={{ width: "70%" }} /> */}
                    <Lottie animationData={introImage} style={{ width: "70%" }} className="d-sm-none mb-5" />
                    <h1 style={{ fontSize: "2em" }}>Hi, I'm Rishi !<span class={styles.wavingHand}>👋</span></h1>
                    <h4 className="mt-4">A Passionate Front-end Developer</h4>
                </div>
                <div className="d-none d-sm-flex col-12 col-sm-6 justify-content-center">
                    {/* <img alt="Rishi Vedpathak" src="/illustrations/intro.svg" className="img-fluid" style={{ width: "70%" }} /> */}
                    <Lottie animationData={introImage} style={{ width: "70%" }} />
                </div>
            </div>
        </WaveBg>
    </div>
)